var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoinHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29468",
    "data-name": "Group 29468",
    transform: "translate(-421.999 -822.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(421.999 822.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-bitcoin",
    transform: "translate(435.041 825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50739",
    "data-name": "Path 50739",
    d: "M22.955,13.478A9.478,9.478,0,1,1,13.478,4,9.479,9.479,0,0,1,22.955,13.478Z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50740",
    "data-name": "Path 50740",
    d: "M17,23.478V14h3.885a4.3,4.3,0,0,1,2.6.661,2.265,2.265,0,0,1,.885,1.936,2.166,2.166,0,0,1-.354,1.227,2.055,2.055,0,0,1-.989.778,1.979,1.979,0,0,1,1.138.737,2.176,2.176,0,0,1,.419,1.352,2.508,2.508,0,0,1-.866,2.069,3.884,3.884,0,0,1-2.467.717Zm1.9-5.687h2.068c.978-.017,1.468-.39,1.468-1.159a1.092,1.092,0,0,0-.372-.927,1.946,1.946,0,0,0-1.174-.283H18.9Zm0,1.422v2.843h2.3c.455,0,1.5-.222,1.5-1.236s-.529-1.594-1.422-1.607Z",
    transform: "translate(-6.84 -5.261)",
    fill: "#fff8e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50741",
    "data-name": "Path 50741",
    d: "M20,11h1.422v2.369H20Zm2.369,0h1.422v2.369H22.369ZM20,20.951h1.422v2.369H20Zm2.369,0h1.422v2.369H22.369Z",
    transform: "translate(-8.418 -3.683)",
    fill: "#fff8e1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoinHighlighted);
export default __webpack_public_path__ + "static/media/bitcoinHighlighted.3213428414b882a2286fd47327947fec.svg";
export { ForwardRef as ReactComponent };